import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COMOCONFIRMUSEPOINTMODAL_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "Textes" },
  "title",
  "cancel_text",
  "validate_text",
  { type: 'heading', value: "Couleurs" },
  "background_color",
  "cancel_font_color",
  "cancel_background_color",
  "validate_font_color",
  "validate_background_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  comoConfirmUsePointModalDescriptor: _generatedComoConfirmUsePointModalDescriptor,
  comoConfirmUsePointModalModalDefinition,
  comoConfirmUsePointModalDashboardLayout,
  comoConfirmUsePointModalConfig,
  comoConfirmUsePointModalResolveConfig,
  comoConfirmUsePointModalProperties,
} = doodModalConfig(
  {
    name: "Como confirm use point modal",
    handle: "como-confirm-use-point-modal",
    internal_name: "Como confirm use point modal",
    componentType: 'ComoConfirmUsePointModalComponent',
    category: 'modal',
    description: "Como confirm use point modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "como-confirm-use-point-modal",
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    }),
    title: propertyValue({
      type: 'translation',
      value: '',
      options: {
        "label": "Titre",
        "variables": [
          {
            "name": "assetName",
            "description": "Nombre de points"
          }
        ]
      }
    }),
    cancel_text: propertyValue({
      type: 'translation',
      value: '',
      options: {
        "label": "Cancel button"
      }
    }),
    validate_text: propertyValue({
      type: 'translation',
      value: '',
      options: {
        "label": "Validate button"
      }
    }),
    cancel_font_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: 'Cancel button — text color',
      },
    }),
    cancel_background_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: 'Cancel button — background color',
      },
    }),
    validate_font_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: 'Validate button — text color',
      },
    }),
    validate_background_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: 'Validate button — background color',
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [
              "background_color",
              "title",
              "cancel_text",
              "validate_text",
              "cancel_font_color",
              "cancel_background_color",
              "validate_font_color",
              "validate_background_color",
            ],
          },
        ],
      },
    ],
  })
);

export function comoConfirmUsePointModalDescriptor(): IBlockDescriptor;
export function comoConfirmUsePointModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoConfirmUsePointModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoConfirmUsePointModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedComoConfirmUsePointModalDescriptor, comoConfirmUsePointModalProperties, fieldOrder);
}

export {
  comoConfirmUsePointModalModalDefinition,
  comoConfirmUsePointModalDashboardLayout,
  comoConfirmUsePointModalProperties,
  comoConfirmUsePointModalConfig,
  comoConfirmUsePointModalResolveConfig,
};

export type ComoConfirmUsePointModalConfig = typeof comoConfirmUsePointModalConfig;
